import {atom} from "recoil";


export const LoadingAtom = atom({
    key: "LoadingAtom",
    default: true,
});